import presetModel from '../../constants/presetModelBuilder.json'

const paramKeys = {
  button: ['note', 'cc', 'bankMSB', 'bankLSB', 'patch', 'channel'],
  split:  ['bar', 'curve', 'channel'],
  fader:  ['mode', 'cc', 'channel'],
  pedal:  ['mode', 'cc', 'channel'], // 3rd pedal doesn't have mode. ignore?
  gapCaps: ['notes', 'curve', 'channel'],
  playParams: ['playMode', 'noteOnTime', 'dampThreshold']
}

export default class PresetBuilder {
  constructor() {
    this._preset = Object.assign({}, presetModel)
  }

  _buildParam(paramObject) {
    const index = getParamIndex(paramObject),
          paramName = getParamName(paramObject),
          paramMember = isParamGroup(paramObject.param) ? this._buildParamMember(paramObject) : paramObject.values

    return {
      param: paramName,
      index: index,
      member: paramMember
    }
  }

  _buildParamMember(paramObject) {
    const keys = paramKeys[paramObject.param],
          notes = []

    return paramObject.values.reduce((o,v,i) => {
      if(paramObject.param === 'gapCaps'){
        if(i < 6){
          notes.push(v)
          o[keys[0]] = notes
        }
        else {
          o[keys[i-5]] = v
        }
      } else {
        o[keys[i]] = v
      }

      return o
    }, {})
  }

  _addToPreset(paramMember){
    const { param, index, member } = paramMember

    switch (index) {
      case -2: // gapCaps & playParams
        this._preset[param] = { ...member }
        break;
      case -1: // single params
        this._preset[param] = (param === 'gain') ?  member[0].toFixed(2) : member[0]
        break;
      default: // groups
        this._preset[param] = [
          ...this._preset[param].slice(0, index),
          member,
          ...this._preset[param].slice(index)
        ]
    }
  }

  add(paramObj) {
    this._addToPreset(this._buildParam(paramObj))
  }

  get() {
    const buildPreset = this._preset
    this._preset = {}
    return buildPreset
   }
}

function getParamIndex(paramObject) {
  const specialCases = ['gapCaps', 'playParams']
  return isParamGroup(paramObject.param) ? specialCases.includes(paramObject.param) ? -2 : paramObject.values.splice(0,1)[0] : -1
}

function getParamName(paramObject) {
  const specialCases = ['gapCaps', 'playParams']
  let paramName
  if (isParamGroup(paramObject.param) && !specialCases.includes(paramObject.param)) {
  	paramName = paramObject.param + 's'
  } else {
    paramName = paramObject.param
  }

  return paramName
}

function isParamGroup(param) {
	return ['button', 'split', 'fader', 'pedal', 'gapCaps', 'playParams'].includes(param)
}
